import type { Routes } from '@angular/router';
import { secureRoute } from './core/utils/transformers';
import { CompanyStructureViewComponent } from './features/companies/pages/company-structure-view/company-structure-view';

export const companiesRoutes: Routes = [
  secureRoute({
    path: 'companies',
    component: CompanyStructureViewComponent,
    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'organizacja',
          isCurrent: true,
          url: '/companies',
        },
      ],
    },
  }),
];
